/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Fullscreen_ModeInputs */

const en_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle fullscreen mode`)
};

const fr_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le mode plein écran`)
};

const de_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbildmodus umschalten`)
};

const it_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la modalità a schermo intero`)
};

const ru_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить полноэкранный режим`)
};

const es_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar el modo de pantalla completa`)
};

const zh_cn2_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换全屏模式`)
};

const ja_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面モードを切り替える`)
};

const hi_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ुलस्क्रीन मोड चालू/बंद करें`)
};

const pt_pt2_toggle_fullscreen_mode = /** @type {(inputs: Toggle_Fullscreen_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar modo de tela cheia`)
};

/**
* | output |
* | --- |
* | "Toggle fullscreen mode" |
*
* @param {Toggle_Fullscreen_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_fullscreen_mode = /** @type {((inputs?: Toggle_Fullscreen_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Fullscreen_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toggle_fullscreen_mode(inputs)
	if (locale === "de") return de_toggle_fullscreen_mode(inputs)
	if (locale === "it") return it_toggle_fullscreen_mode(inputs)
	if (locale === "ru") return ru_toggle_fullscreen_mode(inputs)
	if (locale === "es") return es_toggle_fullscreen_mode(inputs)
	if (locale === "zh-CN") return zh_cn2_toggle_fullscreen_mode(inputs)
	if (locale === "ja") return ja_toggle_fullscreen_mode(inputs)
	if (locale === "hi") return hi_toggle_fullscreen_mode(inputs)
	if (locale === "pt-PT") return pt_pt2_toggle_fullscreen_mode(inputs)
	return en_toggle_fullscreen_mode(inputs)
});